export default __webpack_public_path__ + "static/media/Hair_18_F_C3.46bbd0ce.svg";